import { useState, useCallback, useEffect, RefObject } from "react";

interface Resize {
  width: number | null;
  height: number | null;
  remeasure: () => void;
}

export function useResize(myRef: RefObject<HTMLDivElement | null>): Resize {
  const [width, setWidth] = useState<number | null>(null);
  const [height, setHeight] = useState<number | null>(null);

  const handleResize = useCallback(() => {
    setWidth(myRef.current?.offsetWidth ?? null);
    setHeight(myRef.current?.offsetHeight ?? null);
  }, [myRef]);

  useEffect(() => {
    handleResize();
  }, []);

  useEffect(() => {
    window.addEventListener("load", handleResize);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("load", handleResize);
      window.removeEventListener("resize", handleResize);
    };
  }, [myRef, handleResize]);

  return { width, height, remeasure: handleResize };
}
